import Vue from "vue";
import {Component, Prop} from "vue-property-decorator";
import "./globalNotification.styl";
import {eventBus, signalNames} from "../../../bus";
const template = require("./globalNotification.vue");

@Component({
  template: template
})
export default class GlobalNotificationComponent extends Vue {

  defaultErrorMessage = "There has been an error with your request";
  notifications: {text: string, value: boolean}[] = [];
  timeout = 6000;

  created() {
    eventBus.$on(signalNames.showError, this.addSnackBar);
  }

  beforeDestroy() {
    eventBus.$off(signalNames.showError, this.addSnackBar);
  }

  addSnackBar(customMessage?: string) {
    const notification = { text: customMessage || this.defaultErrorMessage, value: true };
    this.notifications.push(notification);
    setTimeout(() => this.removeSnackBar(notification), this.timeout);
  }

  removeSnackBar(snackBar: {text: string, value: boolean}) {
    this.notifications.splice(this.notifications.indexOf(snackBar), 1);
  }

}

Vue.component("cmGlobalNotification", GlobalNotificationComponent);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/plain/globalNotification/globalNotification.ts